export default __webpack_public_path__ + "static/media/item2.f5229c04.png";